import { createSlice } from "@reduxjs/toolkit";
import {
  getAboutStatsSection,
  updateAboutStatsSection,
} from "actions/aboutStatsSection";

const initialState = {
  loading: false,
  aboutStatsSection: null,
  updateLoading: false,
  error: null,
};

export const aboutStatsSectionSlice = createSlice({
  name: "aboutStatsSection",
  initialState,
  reducers: {
    clearAboutStatsSection: (state) => {
      state.aboutStatsSection = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAboutStatsSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAboutStatsSection.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.aboutStatsSection = payload;
      })
      .addCase(getAboutStatsSection.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(updateAboutStatsSection.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateAboutStatsSection.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.aboutStatsSection = payload;
      })
      .addCase(updateAboutStatsSection.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export const { clearAboutStatsSection, clearError } =
  aboutStatsSectionSlice.actions;

export default aboutStatsSectionSlice.reducer;
